// Extracted from mind .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const MIND_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.69019997, 0.35690001, 0.06270000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.05880000, 0.07060000, 0.01570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const MIND_MESH_0: RuneMesh = {
  name: "Mind_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.44040000, 0.43310001, 0.54289997,
    0.44040000, 0.43310001, 0.54289997,
    0.44040000, 0.43310001, 0.54289997,
    0.53880000, 0.43310001, 0.44199997,
    0.53880000, 0.43310001, 0.44199997,
    0.53880000, 0.43310001, 0.44199997,
    0.34430000, 0.43310001, 0.31229997,
    0.34430000, 0.43310001, 0.31229997,
    0.24580000, 0.43310001, 0.40119997,
    0.24580000, 0.43310001, 0.40119997,
    0.24580000, 0.43310001, 0.40119997,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    0.07770000, 0.43310004, 0.72789997,
    0.07770000, 0.43310004, 0.72789997,
    0.07770000, 0.43310004, 0.72789997,
    0.02000000, 0.43310001, 0.53329992,
    0.02000000, 0.43310001, 0.53329992,
    0.02000000, 0.43310001, 0.53329992,
    0.02720000, 0.43310001, 0.44919997,
    0.02720000, 0.43310001, 0.44919997,
    0.02720000, 0.43310001, 0.44919997,
    0.35150000, 0.43310001, 0.21139997,
    0.35150000, 0.43310001, 0.21139997,
    0.43560001, 0.43309999, 0.07689997,
    0.43560001, 0.43309999, 0.07689997,
    0.43560001, 0.43309999, 0.07689997,
    0.68059999, 0.43309999, 0.07449997,
    0.68059999, 0.43309999, 0.07449997,
    0.68059999, 0.43309999, 0.07449997,
    0.72140002, 0.43309999, -0.07200003,
    0.72140002, 0.43309999, -0.07200003,
    0.72140002, 0.43309999, -0.07200003,
    0.49320000, 0.43309999, -0.07200003,
    0.49320000, 0.43309999, -0.07200003,
    0.49320000, 0.43309999, -0.07200003,
    0.39469999, 0.43309999, -0.16330002,
    0.39469999, 0.43309999, -0.16330002,
    0.39469999, 0.43309999, -0.16330002,
    0.39230001, 0.43309996, -0.34820002,
    0.39230001, 0.43309996, -0.34820002,
    0.39230001, 0.43309996, -0.34820002,
    0.57969999, 0.43309996, -0.48750004,
    0.57969999, 0.43309996, -0.48750004,
    0.57969999, 0.43309996, -0.48750004,
    0.48840001, 0.43309996, -0.58120006,
    0.48840001, 0.43309996, -0.58120006,
    0.48840001, 0.43309996, -0.58120006,
    0.30350000, 0.43309996, -0.38900003,
    0.30350000, 0.43309996, -0.38900003,
    0.30350000, 0.43309996, -0.38900003,
    0.16650000, 0.43309996, -0.39380002,
    0.16650000, 0.43309996, -0.39380002,
    0.06810000, 0.43309996, -0.48510003,
    0.06810000, 0.43309996, -0.48510003,
    0.12330000, 0.43309993, -0.67490005,
    0.12330000, 0.43309993, -0.67490005,
    -0.07360000, 0.43309993, -0.72770005,
    -0.07360000, 0.43309993, -0.72770005,
    -0.07360000, 0.43309993, -0.72770005,
    -0.02080000, 0.43309996, -0.52830005,
    -0.02080000, 0.43309996, -0.52830005,
    -0.02080000, 0.43309996, -0.52830005,
    -0.11690000, 0.43309996, -0.44190004,
    -0.11690000, 0.43309996, -0.44190004,
    -0.34990001, 0.43309996, -0.21370003,
    -0.34990001, 0.43309996, -0.21370003,
    -0.35229999, 0.43309996, -0.38900003,
    -0.35229999, 0.43309996, -0.38900003,
    -0.35229999, 0.43309996, -0.38900003,
    -0.25619999, 0.43309996, -0.44190004,
    -0.25619999, 0.43309996, -0.44190004,
    -0.44589999, 0.43309993, -0.62920004,
    -0.44589999, 0.43309993, -0.62920004,
    -0.44589999, 0.43309993, -0.62920004,
    -0.53719997, 0.43309996, -0.52590007,
    -0.53719997, 0.43309996, -0.52590007,
    -0.53719997, 0.43309996, -0.52590007,
    -0.39789999, 0.43309999, 0.16819997,
    -0.39789999, 0.43309999, 0.16819997,
    -0.48440000, 0.43309999, 0.02889997,
    -0.48440000, 0.43309999, 0.02889997,
    -0.48440000, 0.43309999, 0.02889997,
    -0.43869999, 0.43309999, -0.11760003,
    -0.43869999, 0.43309999, -0.11760003,
    -0.67890000, 0.43309999, -0.12480003,
    -0.67890000, 0.43309999, -0.12480003,
    -0.72939998, 0.43309999, 0.01929997,
    -0.72939998, 0.43309999, 0.01929997,
    -0.72939998, 0.43309999, 0.01929997,
    -0.07120000, 0.43310001, 0.48049998,
    -0.07120000, 0.43310001, 0.48049998,
    -0.11690000, 0.43310004, 0.68219995,
    -0.11690000, 0.43310004, 0.68219995,
    -0.11690000, 0.43310004, 0.68219995,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.48920000, 0.43310001, 0.49249998,
    -0.48920000, 0.43310001, 0.49249998,
    -0.48920000, 0.43310001, 0.49249998,
    -0.30180001, 0.43310001, 0.35079998,
    -0.30180001, 0.43310001, 0.35079998,
    -0.30180001, 0.43310001, 0.35079998,
    -0.39309999, 0.43310001, 0.25229996,
    -0.39309999, 0.43310001, 0.25229996,
    -0.58289999, 0.43310001, 0.39639997,
    -0.58289999, 0.43310001, 0.39639997,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    0.30350000, 0.35719997, -0.38900003,
    0.30350000, 0.35719997, -0.38900003,
    0.39230001, 0.35719997, -0.34820002,
    0.39230001, 0.35719997, -0.34820002,
    0.57969999, 0.35719997, -0.48750004,
    0.57969999, 0.35719997, -0.48750004,
    0.48840001, 0.35719997, -0.58120000,
    0.48840001, 0.35719997, -0.58120000,
    -0.07360000, 0.35719994, -0.72770000,
    -0.07360000, 0.35719994, -0.72770000,
    -0.02080000, 0.35719997, -0.52829999,
    -0.02080000, 0.35719997, -0.52829999,
    0.06810000, 0.35719997, -0.48510003,
    0.12330000, 0.35719994, -0.67490000,
    -0.25619999, 0.35719997, -0.44190004,
    -0.44589999, 0.35719994, -0.62919998,
    -0.44589999, 0.35719994, -0.62919998,
    -0.53719997, 0.35719997, -0.52590001,
    -0.53719997, 0.35719997, -0.52590001,
    -0.35229999, 0.35719997, -0.38900003,
    -0.72939998, 0.35720000, 0.01929997,
    -0.72939998, 0.35720000, 0.01929997,
    -0.48440000, 0.35720000, 0.02889997,
    -0.48440000, 0.35720000, 0.02889997,
    -0.43869999, 0.35720000, -0.11760003,
    -0.67890000, 0.35720000, -0.12480003,
    -0.58289999, 0.35720003, 0.39639997,
    -0.48920000, 0.35720003, 0.49249998,
    -0.48920000, 0.35720003, 0.49249998,
    -0.30180001, 0.35720003, 0.35079998,
    -0.30180001, 0.35720003, 0.35079998,
    -0.39309999, 0.35720003, 0.25229996,
    0.07770000, 0.35720006, 0.72790003,
    0.07770000, 0.35720006, 0.72790003,
    0.02000000, 0.35720003, 0.53329998,
    0.02000000, 0.35720003, 0.53329998,
    -0.07120000, 0.35720003, 0.48049998,
    -0.11690000, 0.35720006, 0.68220001,
    0.24580000, 0.35720003, 0.40119997,
    0.44040000, 0.35720003, 0.54290003,
    0.44040000, 0.35720003, 0.54290003,
    0.53880000, 0.35720003, 0.44199997,
    0.53880000, 0.35720003, 0.44199997,
    0.34430000, 0.35720003, 0.31229997,
    0.43560001, 0.35720000, 0.07689997,
    0.43560001, 0.35720000, 0.07689997,
    0.68059999, 0.35720000, 0.07449997,
    0.68059999, 0.35720000, 0.07449997,
    0.72140002, 0.35720000, -0.07200003,
    0.72140002, 0.35720000, -0.07200003,
    0.49320000, 0.35720000, -0.07200003,
    0.49320000, 0.35720000, -0.07200003,
    0.35150000, 0.35720003, 0.21139997,
    0.39469999, 0.35720000, -0.16330002,
    0.16650000, 0.35719997, -0.39380002,
    0.02720000, 0.35720003, 0.44919997,
    0.02720000, 0.35720003, 0.29789996,
    0.20739999, 0.35720003, 0.20899998,
    0.25780001, 0.35720000, -0.16090003,
    0.15930000, 0.35719997, -0.25450003,
    0.15930000, 0.35719997, -0.25450003,
    -0.10970000, 0.35719997, -0.30020002,
    -0.21300000, 0.35719997, -0.20650002,
    -0.25860000, 0.35720000, 0.16579998,
    -0.39789999, 0.35720000, 0.16819997,
    -0.34990001, 0.35719997, -0.21370003,
    -0.11690000, 0.35719997, -0.44190004,
    -0.25860000, 0.43309999, 0.16579998,
    -0.25860000, 0.43309999, 0.16579998,
    -0.25860000, 0.43309999, 0.16579998,
    0.02720000, 0.43310001, 0.29789996,
    0.02720000, 0.43310001, 0.29789996,
    -0.21300000, 0.43309996, -0.20650002,
    -0.21300000, 0.43309996, -0.20650002,
    -0.10970000, 0.43309996, -0.30020002,
    -0.10970000, 0.43309996, -0.30020002,
    0.15930000, 0.43309996, -0.25450003,
    0.15930000, 0.43309996, -0.25450003,
    0.15930000, 0.43309996, -0.25450003,
    0.25780001, 0.43309999, -0.16090003,
    0.25780001, 0.43309999, -0.16090003,
    0.20739999, 0.43310001, 0.20899998,
    0.20739999, 0.43310001, 0.20899998,
    0.12330000, 0.43309999, 0.02649997,
    0.12330000, 0.43309999, 0.02649997,
    0.12330000, 0.43309999, 0.02649997,
    0.02000000, 0.43309999, 0.02889997,
    0.02000000, 0.43309999, 0.02889997,
    0.02000000, 0.43309999, 0.02889997,
    0.02000000, 0.43309999, 0.02889997,
    0.02000000, 0.35720000, 0.02889997,
    0.02000000, 0.35720000, 0.02889997,
    0.12330000, 0.35720000, 0.02649997,
    0.12330000, 0.35720000, 0.02649997,
    0.15449999, 0.43309999, -0.16090003,
    0.15449999, 0.43309999, -0.16090003,
    0.15449999, 0.35720000, -0.16090003,
    0.06330000, 0.35720000, -0.16090003,
    0.06330000, 0.43309999, -0.16090003,
    0.06330000, 0.43309999, -0.16090003,
    -0.02800000, 0.43309996, -0.20410003,
    -0.02800000, 0.43309996, -0.20410003,
    -0.02800000, 0.43309996, -0.20410003,
    -0.01600000, 0.43309999, -0.02150003,
    -0.01600000, 0.43309999, -0.02150003,
    -0.01600000, 0.35720000, -0.02150003,
    -0.02800000, 0.35719997, -0.20410003,
    -0.02800000, 0.35719997, -0.20410003,
    -0.11690000, 0.43309996, -0.20410003,
    -0.11690000, 0.43309996, -0.20410003,
    -0.11690000, 0.43309996, -0.20410003,
    -0.11690000, 0.35719997, -0.20410003,
    -0.11690000, 0.35719997, -0.20410003,
    -0.11690000, 0.35720000, -0.02150003,
    -0.11690000, 0.35720000, -0.02150003,
    -0.11690000, 0.43309999, -0.02150003,
    -0.11690000, 0.43309999, -0.02150003,
    -0.11690000, 0.43309999, -0.02150003,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 115, 38, 35, 35, 118, 119,
    119, 120, 121, 121, 124, 126, 115, 35, 119, 121, 126, 115,
    119, 121, 115, 134, 135, 1, 134, 1, 0, 1, 136, 137,
    1, 137, 2, 3, 2, 138, 3, 138, 4, 4, 138, 139,
    4, 139, 5, 5, 139, 140, 5, 140, 6, 6, 140, 141,
    6, 141, 7, 7, 141, 142, 7, 142, 8, 8, 142, 143,
    8, 143, 9, 9, 143, 144, 9, 144, 10, 10, 144, 145,
    10, 145, 11, 11, 145, 146, 11, 146, 12, 12, 146, 147,
    12, 147, 13, 13, 147, 148, 13, 148, 14, 14, 148, 149,
    14, 149, 15, 15, 149, 150, 15, 150, 16, 16, 150, 151,
    16, 151, 17, 17, 151, 152, 17, 152, 18, 18, 152, 153,
    18, 153, 19, 19, 153, 154, 19, 154, 20, 20, 154, 155,
    20, 155, 21, 21, 155, 156, 21, 156, 33, 33, 156, 157,
    33, 157, 34, 34, 157, 158, 34, 158, 35, 35, 158, 159,
    35, 159, 118, 118, 159, 160, 118, 160, 119, 119, 160, 161,
    119, 161, 120, 120, 161, 162, 120, 162, 121, 121, 162, 163,
    121, 163, 132, 132, 163, 164, 132, 164, 133, 133, 164, 135,
    133, 135, 134, 135, 165, 136, 135, 136, 1, 136, 166, 167,
    136, 167, 137, 2, 137, 168, 2, 168, 138, 138, 168, 169,
    138, 169, 139, 139, 169, 170, 139, 170, 140, 140, 170, 171,
    140, 171, 141, 141, 171, 172, 141, 172, 142, 142, 172, 173,
    142, 173, 143, 143, 173, 174, 143, 174, 144, 144, 174, 175,
    144, 175, 145, 145, 175, 176, 145, 176, 146, 146, 176, 177,
    146, 177, 147, 147, 177, 178, 147, 178, 148, 148, 178, 179,
    148, 179, 149, 149, 179, 180, 149, 180, 150, 150, 180, 181,
    150, 181, 151, 151, 181, 182, 151, 182, 152, 152, 182, 183,
    152, 183, 153, 153, 183, 184, 153, 184, 154, 154, 184, 185,
    154, 185, 155, 155, 185, 186, 155, 186, 156, 156, 186, 187,
    156, 187, 157, 157, 187, 188, 157, 188, 158, 158, 188, 189,
    158, 189, 159, 159, 189, 190, 159, 190, 160, 160, 190, 191,
    160, 191, 161, 161, 191, 192, 161, 192, 162, 162, 192, 193,
    162, 193, 163, 163, 193, 194, 163, 194, 164, 164, 194, 165,
    164, 165, 135, 165, 195, 166, 165, 166, 136, 166, 196, 197,
    166, 197, 167, 137, 167, 198, 137, 198, 168, 168, 198, 199,
    168, 199, 169, 169, 199, 200, 169, 200, 170, 170, 200, 201,
    170, 201, 171, 171, 201, 202, 171, 202, 172, 172, 202, 203,
    172, 203, 173, 173, 203, 204, 173, 204, 174, 174, 204, 205,
    174, 205, 175, 175, 205, 206, 175, 206, 176, 176, 206, 207,
    176, 207, 177, 177, 207, 208, 177, 208, 178, 178, 208, 209,
    178, 209, 179, 179, 209, 210, 179, 210, 180, 180, 210, 211,
    180, 211, 181, 181, 211, 212, 181, 212, 182, 182, 212, 213,
    182, 213, 183, 183, 213, 214, 183, 214, 184, 184, 214, 215,
    184, 215, 185, 185, 215, 216, 185, 216, 186, 186, 216, 217,
    186, 217, 187, 187, 217, 218, 187, 218, 188, 188, 218, 219,
    188, 219, 189, 189, 219, 220, 189, 220, 190, 190, 220, 221,
    190, 221, 191, 191, 221, 222, 191, 222, 192, 192, 222, 223,
    192, 223, 193, 193, 223, 224, 193, 224, 194, 194, 224, 195,
    194, 195, 165, 195, 225, 196, 195, 196, 166, 196, 226, 227,
    196, 227, 197, 167, 197, 228, 167, 228, 198, 198, 228, 229,
    198, 229, 199, 199, 229, 230, 199, 230, 200, 200, 230, 231,
    200, 231, 201, 201, 231, 232, 201, 232, 202, 202, 232, 233,
    202, 233, 203, 203, 233, 234, 203, 234, 204, 204, 234, 235,
    204, 235, 205, 205, 235, 236, 205, 236, 206, 206, 236, 237,
    206, 237, 207, 207, 237, 238, 207, 238, 208, 208, 238, 239,
    208, 239, 209, 209, 239, 240, 209, 240, 210, 210, 240, 241,
    210, 241, 211, 211, 241, 242, 211, 242, 212, 212, 242, 243,
    212, 243, 213, 213, 243, 244, 213, 244, 214, 214, 244, 245,
    214, 245, 215, 215, 245, 246, 215, 246, 216, 216, 246, 247,
    216, 247, 217, 217, 247, 248, 217, 248, 218, 218, 248, 249,
    218, 249, 219, 219, 249, 250, 219, 250, 220, 220, 250, 251,
    220, 251, 221, 221, 251, 252, 221, 252, 222, 222, 252, 253,
    222, 253, 223, 223, 253, 254, 223, 254, 224, 224, 254, 225,
    224, 225, 195, 225, 255, 226, 225, 226, 196, 226, 256, 257,
    226, 257, 227, 197, 227, 258, 197, 258, 228, 228, 258, 259,
    228, 259, 229, 229, 259, 260, 229, 260, 230, 230, 260, 261,
    230, 261, 231, 231, 261, 262, 231, 262, 232, 232, 262, 263,
    232, 263, 233, 233, 263, 264, 233, 264, 234, 234, 264, 265,
    234, 265, 235, 235, 265, 266, 235, 266, 236, 236, 266, 267,
    236, 267, 237, 237, 267, 268, 237, 268, 238, 238, 268, 269,
    238, 269, 239, 239, 269, 270, 239, 270, 240, 240, 270, 271,
    240, 271, 241, 241, 271, 272, 241, 272, 242, 242, 272, 273,
    242, 273, 243, 243, 273, 274, 243, 274, 244, 244, 274, 275,
    244, 275, 245, 245, 275, 276, 245, 276, 246, 246, 276, 277,
    246, 277, 247, 247, 277, 278, 247, 278, 248, 248, 278, 279,
    248, 279, 249, 249, 279, 280, 249, 280, 250, 250, 280, 281,
    250, 281, 251, 251, 281, 282, 251, 282, 252, 252, 282, 283,
    252, 283, 253, 253, 283, 284, 253, 284, 254, 254, 284, 255,
    254, 255, 225, 255, 285, 256, 255, 256, 226, 256, 288, 290,
    256, 290, 257, 227, 257, 291, 227, 291, 258, 258, 291, 292,
    258, 292, 259, 259, 292, 293, 259, 293, 260, 260, 293, 294,
    260, 294, 261, 261, 294, 295, 261, 295, 262, 262, 295, 296,
    262, 296, 263, 263, 296, 297, 263, 297, 264, 264, 297, 298,
    264, 298, 265, 265, 298, 299, 265, 299, 266, 266, 299, 300,
    266, 300, 267, 267, 300, 301, 267, 301, 268, 268, 301, 302,
    268, 302, 269, 269, 302, 303, 269, 303, 270, 270, 303, 304,
    270, 304, 271, 271, 304, 305, 271, 305, 272, 272, 305, 306,
    272, 306, 273, 273, 306, 307, 273, 307, 274, 274, 307, 308,
    274, 308, 275, 275, 308, 309, 275, 309, 276, 276, 309, 310,
    276, 310, 277, 277, 310, 311, 277, 311, 278, 278, 311, 312,
    278, 312, 279, 279, 312, 313, 279, 313, 280, 280, 313, 314,
    280, 314, 281, 281, 314, 315, 281, 315, 282, 282, 315, 316,
    282, 316, 283, 283, 316, 317, 283, 317, 284, 284, 317, 285,
    284, 285, 255, 285, 319, 288, 285, 288, 256, 286, 320, 322,
    286, 322, 289, 257, 290, 324, 257, 324, 291, 291, 324, 326,
    291, 326, 292, 292, 326, 328, 292, 328, 293, 293, 328, 330,
    293, 330, 294, 294, 330, 332, 294, 332, 295, 295, 332, 334,
    295, 334, 296, 296, 334, 336, 296, 336, 297, 297, 336, 338,
    297, 338, 298, 298, 338, 339, 298, 339, 299, 299, 339, 341,
    299, 341, 300, 300, 341, 343, 300, 343, 301, 301, 343, 345,
    301, 345, 302, 302, 345, 347, 302, 347, 303, 303, 347, 349,
    303, 349, 304, 304, 349, 351, 304, 351, 305, 305, 351, 353,
    305, 353, 306, 306, 353, 355, 306, 355, 307, 307, 355, 357,
    307, 357, 308, 308, 357, 359, 308, 359, 309, 309, 359, 361,
    309, 361, 310, 310, 361, 363, 310, 363, 311, 311, 363, 365,
    311, 365, 312, 312, 365, 367, 312, 367, 313, 313, 367, 369,
    313, 369, 314, 314, 369, 371, 314, 371, 315, 315, 371, 374,
    315, 374, 316, 316, 374, 376, 316, 376, 317, 317, 376, 319,
    317, 319, 285, 318, 377, 321, 318, 321, 287, 320, 378, 381,
    320, 381, 322, 289, 322, 383, 289, 383, 323, 323, 383, 384,
    323, 384, 325, 325, 384, 385, 325, 385, 327, 327, 385, 386,
    327, 386, 329, 329, 386, 387, 329, 387, 331, 331, 387, 388,
    331, 388, 333, 333, 388, 389, 333, 389, 335, 335, 389, 390,
    335, 390, 337, 337, 390, 391, 337, 391, 340, 340, 391, 392,
    340, 392, 342, 342, 392, 393, 342, 393, 344, 344, 393, 394,
    344, 394, 346, 346, 394, 395, 346, 395, 348, 348, 395, 396,
    348, 396, 350, 350, 396, 397, 350, 397, 352, 352, 397, 398,
    352, 398, 354, 354, 398, 399, 354, 399, 356, 356, 399, 400,
    356, 400, 358, 358, 400, 401, 358, 401, 360, 360, 401, 402,
    360, 402, 362, 362, 402, 403, 362, 403, 364, 364, 403, 404,
    364, 404, 366, 366, 404, 405, 366, 405, 368, 368, 405, 406,
    368, 406, 370, 370, 406, 407, 370, 407, 372, 372, 407, 408,
    372, 408, 373, 373, 408, 409, 373, 409, 375, 375, 409, 377,
    375, 377, 318, 377, 410, 380, 377, 380, 321, 379, 412, 413,
    379, 413, 382, 322, 381, 414, 322, 414, 383, 383, 414, 416,
    383, 416, 384, 384, 416, 418, 384, 418, 385, 385, 418, 420,
    385, 420, 386, 386, 420, 422, 386, 422, 387, 387, 422, 424,
    387, 424, 388, 388, 424, 426, 388, 426, 389, 389, 426, 428,
    389, 428, 390, 390, 428, 431, 390, 431, 391, 391, 431, 433,
    391, 433, 392, 392, 433, 435, 392, 435, 393, 393, 435, 437,
    393, 437, 394, 394, 437, 439, 394, 439, 395, 395, 439, 441,
    395, 441, 396, 396, 441, 443, 396, 443, 397, 397, 443, 445,
    397, 445, 398, 398, 445, 447, 398, 447, 399, 399, 447, 449,
    399, 449, 400, 400, 449, 451, 400, 451, 401, 401, 451, 453,
    401, 453, 402, 402, 453, 455, 402, 455, 403, 403, 455, 457,
    403, 457, 404, 404, 457, 459, 404, 459, 405, 405, 459, 461,
    405, 461, 406, 406, 461, 463, 406, 463, 407, 407, 463, 464,
    407, 464, 408, 408, 464, 466, 408, 466, 409, 409, 466, 410,
    409, 410, 377, 411, 468, 412, 411, 412, 379, 412, 469, 470,
    412, 470, 413, 382, 413, 471, 382, 471, 415, 415, 471, 472,
    415, 472, 417, 417, 472, 473, 417, 473, 419, 419, 473, 474,
    419, 474, 421, 421, 474, 475, 421, 475, 423, 423, 475, 476,
    423, 476, 425, 425, 476, 477, 425, 477, 427, 427, 477, 478,
    427, 478, 429, 429, 478, 479, 429, 479, 430, 430, 479, 480,
    430, 480, 432, 432, 480, 481, 432, 481, 434, 434, 481, 482,
    434, 482, 436, 436, 482, 483, 436, 483, 438, 438, 483, 484,
    438, 484, 440, 440, 484, 485, 440, 485, 442, 442, 485, 486,
    442, 486, 444, 444, 486, 487, 444, 487, 446, 446, 487, 488,
    446, 488, 448, 448, 488, 489, 448, 489, 450, 450, 489, 490,
    450, 490, 452, 452, 490, 491, 452, 491, 454, 454, 491, 492,
    454, 492, 456, 456, 492, 493, 456, 493, 458, 458, 493, 494,
    458, 494, 460, 460, 494, 495, 460, 495, 462, 462, 495, 496,
    462, 496, 465, 465, 496, 497, 465, 497, 467, 467, 497, 468,
    467, 468, 411, 468, 498, 469, 468, 469, 412, 469, 499, 500,
    469, 500, 470, 413, 470, 501, 413, 501, 471, 471, 501, 502,
    471, 502, 472, 472, 502, 503, 472, 503, 473, 473, 503, 504,
    473, 504, 474, 474, 504, 505, 474, 505, 475, 475, 505, 506,
    475, 506, 476, 476, 506, 507, 476, 507, 477, 477, 507, 508,
    477, 508, 478, 478, 508, 509, 478, 509, 479, 479, 509, 510,
    479, 510, 480, 480, 510, 511, 480, 511, 481, 481, 511, 512,
    481, 512, 482, 482, 512, 513, 482, 513, 483, 483, 513, 514,
    483, 514, 484, 484, 514, 515, 484, 515, 485, 485, 515, 516,
    485, 516, 486, 486, 516, 517, 486, 517, 487, 487, 517, 518,
    487, 518, 488, 488, 518, 519, 488, 519, 489, 489, 519, 520,
    489, 520, 490, 490, 520, 521, 490, 521, 491, 491, 521, 522,
    491, 522, 492, 492, 522, 523, 492, 523, 493, 493, 523, 524,
    493, 524, 494, 494, 524, 525, 494, 525, 495, 495, 525, 526,
    495, 526, 496, 496, 526, 527, 496, 527, 497, 497, 527, 498,
    497, 498, 468, 498, 528, 499, 498, 499, 469, 499, 529, 530,
    499, 530, 500, 470, 500, 531, 470, 531, 501, 501, 531, 532,
    501, 532, 502, 502, 532, 533, 502, 533, 503, 503, 533, 534,
    503, 534, 504, 504, 534, 535, 504, 535, 505, 505, 535, 536,
    505, 536, 506, 506, 536, 537, 506, 537, 507, 507, 537, 538,
    507, 538, 508, 508, 538, 539, 508, 539, 509, 509, 539, 540,
    509, 540, 510, 510, 540, 541, 510, 541, 511, 511, 541, 542,
    511, 542, 512, 512, 542, 543, 512, 543, 513, 513, 543, 544,
    513, 544, 514, 514, 544, 545, 514, 545, 515, 515, 545, 546,
    515, 546, 516, 516, 546, 547, 516, 547, 517, 517, 547, 548,
    517, 548, 518, 518, 548, 549, 518, 549, 519, 519, 549, 550,
    519, 550, 520, 520, 550, 551, 520, 551, 521, 521, 551, 552,
    521, 552, 522, 522, 552, 553, 522, 553, 523, 523, 553, 554,
    523, 554, 524, 524, 554, 555, 524, 555, 525, 525, 555, 556,
    525, 556, 526, 526, 556, 557, 526, 557, 527, 527, 557, 528,
    527, 528, 498, 528, 558, 529, 528, 529, 499, 529, 559, 560,
    529, 560, 530, 500, 530, 561, 500, 561, 531, 531, 561, 562,
    531, 562, 532, 532, 562, 563, 532, 563, 533, 533, 563, 564,
    533, 564, 534, 534, 564, 565, 534, 565, 535, 535, 565, 566,
    535, 566, 536, 536, 566, 567, 536, 567, 537, 537, 567, 568,
    537, 568, 538, 538, 568, 569, 538, 569, 539, 539, 569, 570,
    539, 570, 540, 540, 570, 571, 540, 571, 541, 541, 571, 572,
    541, 572, 542, 542, 572, 573, 542, 573, 543, 543, 573, 574,
    543, 574, 544, 544, 574, 575, 544, 575, 545, 545, 575, 576,
    545, 576, 546, 546, 576, 577, 546, 577, 547, 547, 577, 578,
    547, 578, 548, 548, 578, 579, 548, 579, 549, 549, 579, 580,
    549, 580, 550, 550, 580, 581, 550, 581, 551, 551, 581, 582,
    551, 582, 552, 552, 582, 583, 552, 583, 553, 553, 583, 584,
    553, 584, 554, 554, 584, 585, 554, 585, 555, 555, 585, 586,
    555, 586, 556, 556, 586, 587, 556, 587, 557, 557, 587, 558,
    557, 558, 528, 558, 588, 559, 558, 559, 529, 559, 589, 590,
    559, 590, 560, 530, 560, 591, 530, 591, 561, 561, 591, 592,
    561, 592, 562, 562, 592, 593, 562, 593, 563, 563, 593, 594,
    563, 594, 564, 564, 594, 595, 564, 595, 565, 565, 595, 596,
    565, 596, 566, 566, 596, 597, 566, 597, 567, 567, 597, 598,
    567, 598, 568, 568, 598, 599, 568, 599, 569, 569, 599, 600,
    569, 600, 570, 570, 600, 601, 570, 601, 571, 571, 601, 602,
    571, 602, 572, 572, 602, 603, 572, 603, 573, 573, 603, 604,
    573, 604, 574, 574, 604, 605, 574, 605, 575, 575, 605, 606,
    575, 606, 576, 576, 606, 607, 576, 607, 577, 577, 607, 608,
    577, 608, 578, 578, 608, 609, 578, 609, 579, 579, 609, 610,
    579, 610, 580, 580, 610, 611, 580, 611, 581, 581, 611, 612,
    581, 612, 582, 582, 612, 613, 582, 613, 583, 583, 613, 614,
    583, 614, 584, 584, 614, 615, 584, 615, 585, 585, 615, 616,
    585, 616, 586, 586, 616, 617, 586, 617, 587, 587, 617, 588,
    587, 588, 558, 588, 618, 589, 588, 589, 559, 589, 619, 620,
    589, 620, 590, 560, 590, 621, 560, 621, 591, 591, 621, 622,
    591, 622, 592, 592, 622, 623, 592, 623, 593, 593, 623, 624,
    593, 624, 594, 594, 624, 625, 594, 625, 595, 595, 625, 626,
    595, 626, 596, 596, 626, 627, 596, 627, 597, 597, 627, 628,
    597, 628, 598, 598, 628, 629, 598, 629, 599, 599, 629, 630,
    599, 630, 600, 600, 630, 631, 600, 631, 601, 601, 631, 632,
    601, 632, 602, 602, 632, 633, 602, 633, 603, 603, 633, 634,
    603, 634, 604, 604, 634, 635, 604, 635, 605, 605, 635, 636,
    605, 636, 606, 606, 636, 637, 606, 637, 607, 607, 637, 638,
    607, 638, 608, 608, 638, 639, 608, 639, 609, 609, 639, 640,
    609, 640, 610, 610, 640, 641, 610, 641, 611, 611, 641, 642,
    611, 642, 612, 612, 642, 643, 612, 643, 613, 613, 643, 644,
    613, 644, 614, 614, 644, 645, 614, 645, 615, 615, 645, 646,
    615, 646, 616, 616, 646, 647, 616, 647, 617, 617, 647, 618,
    617, 618, 588, 618, 648, 619, 618, 619, 589, 619, 649, 620,
    590, 620, 650, 590, 650, 621, 621, 650, 651, 621, 651, 622,
    622, 651, 652, 622, 652, 623, 623, 652, 653, 623, 653, 624,
    624, 653, 654, 624, 654, 625, 625, 654, 655, 625, 655, 626,
    626, 655, 656, 626, 656, 627, 627, 656, 657, 627, 657, 628,
    628, 657, 658, 628, 658, 629, 629, 658, 659, 629, 659, 630,
    630, 659, 660, 630, 660, 631, 631, 660, 661, 631, 661, 632,
    632, 661, 662, 632, 662, 633, 633, 662, 663, 633, 663, 634,
    634, 663, 664, 634, 664, 635, 635, 664, 665, 635, 665, 636,
    636, 665, 666, 636, 666, 637, 637, 666, 667, 637, 667, 638,
    638, 667, 668, 638, 668, 639, 639, 668, 669, 639, 669, 640,
    640, 669, 670, 640, 670, 641, 641, 670, 671, 641, 671, 642,
    642, 671, 672, 642, 672, 643, 643, 672, 673, 643, 673, 644,
    644, 673, 674, 644, 674, 645, 645, 674, 675, 645, 675, 646,
    646, 675, 676, 646, 676, 647, 647, 676, 648, 647, 648, 618,
    648, 649, 619, 620, 649, 650, 650, 649, 651, 651, 649, 652,
    652, 649, 653, 653, 649, 654, 654, 649, 655, 655, 649, 656,
    656, 649, 657, 657, 649, 658, 658, 649, 659, 659, 649, 660,
    660, 649, 661, 661, 649, 662, 662, 649, 663, 663, 649, 664,
    664, 649, 665, 665, 649, 666, 666, 649, 667, 667, 649, 668,
    668, 649, 669, 669, 649, 670, 670, 649, 671, 671, 649, 672,
    672, 649, 673, 673, 649, 674, 674, 649, 675, 675, 649, 676,
    676, 649, 648, 62, 72, 677, 62, 677, 679, 66, 63, 680,
    66, 680, 681, 73, 69, 683, 73, 683, 678, 70, 67, 682,
    70, 682, 684, 83, 81, 685, 83, 685, 687, 76, 84, 688,
    76, 688, 689, 82, 78, 690, 82, 690, 686, 78, 76, 689,
    78, 689, 690, 95, 93, 691, 95, 691, 692, 99, 96, 693,
    99, 693, 695, 93, 92, 696, 93, 696, 691, 90, 98, 694,
    90, 694, 696, 105, 111, 697, 105, 697, 700, 107, 104, 699,
    107, 699, 701, 112, 109, 702, 112, 702, 698, 109, 107, 701,
    109, 701, 702, 122, 130, 703, 122, 703, 705, 125, 123, 704,
    125, 704, 706, 130, 129, 708, 130, 708, 703, 129, 127, 707,
    129, 707, 708, 41, 37, 710, 41, 710, 712, 113, 39, 711,
    113, 711, 713, 36, 117, 714, 36, 714, 709, 117, 113, 713,
    117, 713, 714, 22, 30, 715, 22, 715, 716, 27, 24, 717,
    27, 717, 719, 30, 28, 720, 30, 720, 715, 28, 25, 718,
    28, 718, 720, 50, 47, 721, 50, 721, 723, 55, 52, 724,
    55, 724, 726, 49, 57, 727, 49, 727, 722, 58, 54, 725,
    58, 725, 728, 61, 45, 729, 61, 729, 730, 75, 61, 730,
    75, 730, 731, 772, 755, 757, 757, 759, 748, 748, 746, 793,
    793, 781, 765, 762, 772, 757, 748, 793, 765, 762, 757, 748,
    765, 762, 748, 45, 43, 732, 45, 732, 729, 87, 75, 731,
    87, 731, 743, 88, 87, 743, 88, 743, 742, 101, 88, 742,
    101, 742, 741, 42, 101, 741, 42, 741, 732, 744, 747, 733,
    744, 733, 740, 749, 744, 740, 749, 740, 739, 751, 749, 739,
    751, 739, 738, 754, 751, 738, 754, 738, 736, 756, 753, 737,
    756, 737, 735, 758, 756, 735, 758, 735, 734, 747, 758, 734,
    747, 734, 733, 761, 764, 768, 761, 768, 770, 771, 760, 769,
    771, 769, 773, 763, 775, 774, 763, 774, 767, 775, 771, 773,
    775, 773, 774, 778, 780, 782, 778, 782, 784, 787, 777, 783,
    787, 783, 788, 780, 794, 791, 780, 791, 782, 792, 785, 789,
    792, 789, 790, 34, 35, 38, 38, 40, 44, 46, 48, 51,
    34, 38, 44, 31, 34, 44, 44, 46, 51, 53, 56, 15,
    53, 15, 16, 16, 17, 18, 18, 19, 20, 20, 21, 23,
    20, 23, 26, 16, 18, 20, 51, 53, 16, 29, 31, 44,
    20, 26, 29, 51, 16, 20, 29, 44, 51, 51, 20, 29,
    21, 33, 34, 34, 32, 23, 34, 23, 21, 64, 59, 74,
    74, 77, 79, 71, 64, 74, 74, 79, 71, 48, 46, 60,
    60, 64, 65, 68, 71, 79, 48, 60, 65, 68, 79, 80,
    56, 48, 65, 15, 56, 65, 13, 14, 15, 11, 12, 13,
    9, 10, 11, 94, 8, 9, 89, 91, 94, 77, 74, 86,
    86, 89, 94, 9, 11, 13, 13, 15, 65, 13, 65, 68,
    86, 94, 9, 85, 77, 86, 13, 68, 80, 80, 85, 86,
    9, 13, 80, 80, 86, 9, 114, 116, 126, 114, 126, 128,
    44, 40, 114, 110, 103, 102, 102, 44, 114, 102, 114, 128,
    110, 102, 128, 131, 124, 121, 110, 128, 131, 4, 106, 108,
    110, 131, 121, 4, 108, 110, 0, 3, 4, 133, 134, 0,
    121, 132, 133, 0, 4, 110, 110, 121, 133, 133, 0, 110,
    106, 4, 5, 5, 6, 7, 7, 8, 94, 7, 94, 97,
    102, 103, 106, 91, 89, 102, 7, 97, 100, 91, 102, 106,
    5, 7, 100, 100, 91, 106, 106, 5, 100, 793, 745, 750,
    750, 752, 755, 755, 772, 776, 776, 766, 781, 776, 781, 779,
    786, 793, 750, 755, 776, 779, 779, 786, 750, 750, 755, 779,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.03589851, 0.99855867, 0.03989835,
    -0.05709877, 0.73248421, -0.67838530,
    -0.05709877, 0.73248421, -0.67838530,
    -0.05709877, 0.73248421, -0.67838530,
    -0.81838946, -0.56819265, 0.08599889,
    -0.81838946, -0.56819265, 0.08599889,
    -0.81838946, -0.56819265, 0.08599889,
    0.05889892, -0.59158919, 0.80408529,
    0.05889892, -0.59158919, 0.80408529,
    0.82243486, -0.56722406, -0.04310183,
    0.82243486, -0.56722406, -0.04310183,
    0.82243130, -0.56722162, -0.04320165,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00629994, 0.99819053, 0.05979943,
    -0.18850468, -0.96582400, -0.17790443,
    -0.18850468, -0.96582400, -0.17790443,
    -0.18850468, -0.96582400, -0.17790443,
    -0.36640031, 0.88460071, 0.28850025,
    -0.36640031, 0.88460071, 0.28850025,
    -0.36640031, 0.88460071, 0.28850025,
    -0.01179960, 0.87137061, -0.49048346,
    -0.01189959, 0.87136958, -0.49048289,
    -0.01189959, 0.87136958, -0.49048289,
    -0.39959775, -0.88679502, -0.23219869,
    -0.39959775, -0.88679502, -0.23219869,
    0.31319606, 0.92458844, -0.21689729,
    0.31319606, 0.92458844, -0.21689729,
    0.31319606, 0.92458844, -0.21689729,
    -0.48981294, -0.59361565, -0.63851684,
    -0.48981294, -0.59361565, -0.63851684,
    -0.48981294, -0.59361565, -0.63851684,
    -0.65739256, -0.56439364, 0.49929434,
    -0.65739256, -0.56439364, 0.49929434,
    -0.65739256, -0.56439364, 0.49929434,
    0.45248983, -0.59928658, 0.66038515,
    0.45248983, -0.59928658, 0.66038515,
    0.45248983, -0.59928658, 0.66038515,
    -0.40189541, -0.90508967, 0.13889841,
    -0.40197928, -0.90505328, 0.13889283,
    -0.40201565, -0.90503519, 0.13890541,
    -0.05440099, 0.85181550, -0.52100949,
    -0.05440099, 0.85181550, -0.52100949,
    -0.05460040, 0.85180620, -0.52100383,
    -0.81857730, -0.57068416, -0.06519819,
    -0.81857730, -0.57068416, -0.06519819,
    -0.81857730, -0.57068416, -0.06519819,
    0.00250006, -0.57561300, 0.81771842,
    0.00249991, -0.57567985, 0.81767137,
    0.00249991, -0.57567985, 0.81767137,
    0.81295954, -0.56167201, -0.15369234,
    0.81291312, -0.56170905, -0.15380248,
    0.81291312, -0.56170905, -0.15380248,
    -0.20039949, -0.90059775, 0.38569903,
    -0.20040722, -0.90063248, 0.38561391,
    -0.18049679, 0.89528405, -0.40729275,
    -0.18049679, 0.89528405, -0.40729275,
    -0.71212531, -0.57632048, 0.40091426,
    -0.71212531, -0.57632048, 0.40091426,
    0.58753312, -0.55473131, 0.58913327,
    0.58750054, -0.55480054, 0.58910057,
    0.58750054, -0.55480054, 0.58910057,
    0.60319587, -0.62429573, -0.49639660,
    0.60319587, -0.62429573, -0.49639660,
    0.60319587, -0.62429573, -0.49639660,
    0.23510876, -0.61772301, 0.75042798,
    0.23509423, -0.61778488, 0.75038160,
    0.78630689, 0.47910417, 0.39010341,
    0.78630689, 0.47910417, 0.39010341,
    0.03630071, 0.84151645, -0.53901050,
    0.03620084, 0.84151948, -0.53901249,
    0.03610097, 0.84152253, -0.53901443,
    -0.81811104, -0.56370763, -0.11370153,
    -0.81811104, -0.56370763, -0.11370153,
    0.02780073, -0.57451521, 0.81802163,
    0.02780073, -0.57451521, 0.81802163,
    0.02779914, -0.57458215, 0.81797467,
    0.81507494, -0.57298238, -0.08569736,
    0.81507494, -0.57298238, -0.08569736,
    0.81504136, -0.57302910, -0.08570435,
    0.80940336, 0.45440188, -0.37200153,
    0.80940336, 0.45440188, -0.37200153,
    -0.27630136, 0.87780429, -0.39130191,
    -0.27630136, 0.87780429, -0.39130191,
    -0.27630136, 0.87780429, -0.39130191,
    -0.67209622, -0.56449679, 0.47919730,
    -0.67209622, -0.56449679, 0.47919730,
    0.45509842, -0.59529793, 0.66219771,
    0.45509842, -0.59529793, 0.66219771,
    0.68310969, -0.56330805, -0.46480661,
    0.68310969, -0.56330805, -0.46480661,
    0.68310969, -0.56330805, -0.46480661,
    0.33079776, -0.56309616, 0.75729489,
    0.33079776, -0.56309616, 0.75729489,
    0.69202867, -0.57772396, -0.43281792,
    0.69199868, -0.57769897, -0.43289921,
    0.69198869, -0.57779055, -0.43279294,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.03630102, 0.99852794, 0.04030113,
    0.03080019, 0.91250580, -0.40790257,
    0.03070029, 0.91250860, -0.40790385,
    0.03070029, 0.91250860, -0.40790385,
    -0.81688492, -0.57228946, -0.07199866,
    -0.81688492, -0.57228946, -0.07199866,
    -0.81688492, -0.57228946, -0.07199866,
    -0.07049564, -0.58266397, 0.80964996,
    -0.07050135, -0.58271117, 0.80961550,
    0.81861228, -0.57110858, 0.06090092,
    0.81856552, -0.57117597, 0.06089743,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    0.81291312, 0.56170905, -0.15380248,
    0.81291312, 0.56170905, -0.15380248,
    -0.08260132, 0.60840977, -0.78931273,
    -0.08260132, 0.60840977, -0.78931273,
    -0.81857196, 0.57068042, -0.06529777,
    -0.81857196, 0.57068042, -0.06529777,
    0.00259991, 0.57567966, 0.81767118,
    0.00259991, 0.57567966, 0.81767118,
    0.58750054, 0.55480054, 0.58910057,
    0.58750054, 0.55480054, 0.58910057,
    0.60319587, 0.62429573, -0.49639660,
    0.60319587, 0.62429573, -0.49639660,
    -0.33320225, 0.56900384, -0.75180509,
    -0.71212531, 0.57632048, 0.40091426,
    -0.81811104, 0.56370763, -0.11370153,
    0.02780073, 0.57451521, 0.81802163,
    0.02780073, 0.57451521, 0.81802163,
    0.81507494, 0.57298238, -0.08569736,
    0.81507494, 0.57298238, -0.08569736,
    0.05349856, 0.60348376, -0.79557857,
    0.68310969, 0.56330805, -0.46480661,
    0.68310969, 0.56330805, -0.46480661,
    -0.46459885, 0.59249850, -0.65809836,
    -0.46459885, 0.59249850, -0.65809836,
    -0.67209622, 0.56449679, 0.47919730,
    0.45509842, 0.59529793, 0.66219771,
    0.81861228, 0.57110858, 0.06090092,
    0.06100070, 0.58420670, -0.80930924,
    0.06100070, 0.58420670, -0.80930924,
    -0.81688492, 0.57228946, -0.07199866,
    -0.81688492, 0.57228946, -0.07199866,
    -0.07050135, 0.58271117, 0.80961550,
    -0.60497150, 0.55487386, -0.57107309,
    -0.60497150, 0.55487386, -0.57107309,
    -0.60851182, 0.63251229, 0.47920932,
    -0.60851182, 0.63251229, 0.47920932,
    0.33079776, 0.56309616, 0.75729489,
    0.69198869, 0.57779055, -0.43279294,
    0.82243486, 0.56722406, -0.04310183,
    -0.06799782, 0.58528125, -0.80797410,
    -0.06799782, 0.58528125, -0.80797410,
    -0.81838946, 0.56819265, 0.08599889,
    -0.81838946, 0.56819265, 0.08599889,
    0.05889892, 0.59158919, 0.80408529,
    0.68110065, 0.56000053, -0.47170045,
    0.68110065, 0.56000053, -0.47170045,
    -0.48981294, 0.59361565, -0.63851684,
    -0.48981294, 0.59361565, -0.63851684,
    -0.65739256, 0.56439364, 0.49929434,
    -0.65739256, 0.56439364, 0.49929434,
    0.45248983, 0.59928658, 0.66038515,
    0.45248983, 0.59928658, 0.66038515,
    -0.67338606, 0.62718704, -0.39139191,
    -0.74053262, 0.62142740, 0.25581130,
    -0.35269687, 0.64429427, 0.67859400,
    -0.01970048, 0.58841426, -0.80831958,
    0.00730001, 0.81980160, 0.57260112,
    0.63978097, -0.61518165, 0.46068629,
    0.74220919, -0.61750763, -0.26040321,
    0.34141967, -0.64693725, -0.68183928,
    0.34139636, -0.64689314, -0.68189280,
    -0.21989657, -0.62069027, -0.75258826,
    -0.68488392, -0.63638504, -0.35489167,
    -0.70192445, -0.59552074, 0.39071360,
    0.72319380, 0.60539482, -0.33239712,
    0.68833069, 0.64002852, 0.34141522,
    0.23509423, 0.61778488, 0.75038160,
    -0.70192445, 0.59552074, 0.39071360,
    -0.70192445, 0.59552074, 0.39071360,
    -0.70197519, 0.59547891, 0.39068620,
    0.01000010, 0.62180595, 0.78310750,
    0.01000010, 0.62180595, 0.78310750,
    -0.68488392, 0.63638504, -0.35489167,
    -0.68488392, 0.63638504, -0.35489167,
    -0.21989657, 0.62069027, -0.75258826,
    -0.21989657, 0.62069027, -0.75258826,
    0.29771262, 0.74693171, -0.59452520,
    0.29769492, 0.74688727, -0.59458989,
    0.29769492, 0.74688727, -0.59458989,
    0.74220919, 0.61750763, -0.26040321,
    0.74220919, 0.61750763, -0.26040321,
    0.63978097, 0.61518165, 0.46068629,
    0.63978097, 0.61518165, 0.46068629,
    -0.53000802, -0.58790892, -0.61110932,
    -0.53000802, -0.58790892, -0.61110932,
    -0.53000802, -0.58790892, -0.61110932,
    0.58289143, 0.65839031, -0.47619301,
    0.58289143, 0.65839031, -0.47619301,
    0.58289143, 0.65839031, -0.47619301,
    0.58282538, 0.65842869, -0.47622077,
    0.63873512, 0.56543107, -0.52182866,
    0.63873512, 0.56543107, -0.52182866,
    -0.53000802, 0.58790892, -0.61110932,
    -0.53000802, 0.58790892, -0.61110932,
    -0.40481261, 0.84762635, 0.34301067,
    -0.40481261, 0.84762635, 0.34301067,
    -0.62736498, 0.56916820, 0.53147035,
    0.50349557, 0.59009486, 0.63109451,
    0.50349557, -0.59009486, 0.63109451,
    0.50349557, -0.59009486, 0.63109451,
    -0.55637234, -0.58087116, 0.59417044,
    -0.55637234, -0.58087116, 0.59417044,
    -0.55640540, -0.58090565, 0.59410576,
    -0.27980432, 0.92361433, -0.26200405,
    -0.27980432, 0.92361433, -0.26200405,
    -0.59770437, 0.57400420, -0.55970409,
    -0.55637234, 0.58087116, 0.59417044,
    -0.55637234, 0.58087116, 0.59417044,
    0.57738361, -0.57728359, 0.57738361,
    0.57731691, -0.57741698, 0.57731691,
    0.57728359, -0.57738361, 0.57738361,
    0.57738361, 0.57728359, 0.57738361,
    0.57738361, 0.57738361, 0.57728359,
    0.57738361, 0.57728359, -0.57738361,
    0.57728359, 0.57738361, -0.57738361,
    0.57738361, -0.57738361, -0.57728359,
    0.57738361, -0.57738361, -0.57728359,
    0.57738361, -0.57728359, -0.57738361,
  ]),
  materialIndex: 0,
};

const MIND_MESH_1: RuneMesh = {
  name: "Mind_Rune_primitive1",
  positions: new Float32Array([
    0.30350000, 0.35719997, -0.38900003,
    0.39230001, 0.35719997, -0.34820002,
    0.57969999, 0.35719997, -0.48750004,
    0.48840001, 0.35719997, -0.58120000,
    -0.07360000, 0.35719994, -0.72770000,
    -0.02080000, 0.35719997, -0.52829999,
    0.06810000, 0.35719997, -0.48510003,
    0.12330000, 0.35719994, -0.67490000,
    -0.25619999, 0.35719997, -0.44190004,
    -0.44589999, 0.35719994, -0.62919998,
    -0.53719997, 0.35719997, -0.52590001,
    -0.35229999, 0.35719997, -0.38900003,
    -0.72939998, 0.35720000, 0.01929997,
    -0.48440000, 0.35720000, 0.02889997,
    -0.43869999, 0.35720000, -0.11760003,
    -0.67890000, 0.35720000, -0.12480003,
    -0.58289999, 0.35720003, 0.39639997,
    -0.48920000, 0.35720003, 0.49249998,
    -0.30180001, 0.35720003, 0.35079998,
    -0.39309999, 0.35720003, 0.25229996,
    0.07770000, 0.35720006, 0.72790003,
    0.02000000, 0.35720003, 0.53329998,
    -0.07120000, 0.35720003, 0.48049998,
    -0.11690000, 0.35720006, 0.68220001,
    0.24580000, 0.35720003, 0.40119997,
    0.44040000, 0.35720003, 0.54290003,
    0.53880000, 0.35720003, 0.44199997,
    0.34430000, 0.35720003, 0.31229997,
    0.43560001, 0.35720000, 0.07689997,
    0.68059999, 0.35720000, 0.07449997,
    0.72140002, 0.35720000, -0.07200003,
    0.49320000, 0.35720000, -0.07200003,
  ]),
  indices: new Uint16Array([
    1, 0, 3, 1, 3, 2, 5, 4, 7, 5, 7, 6,
    9, 8, 11, 9, 11, 10, 13, 12, 15, 13, 15, 14,
    17, 16, 19, 17, 19, 18, 21, 20, 23, 21, 23, 22,
    25, 24, 27, 25, 27, 26, 29, 28, 31, 29, 31, 30,
  ]),
  normals: new Float32Array([
    0.81291312, 0.56170905, -0.15380248,
    -0.08260132, 0.60840977, -0.78931273,
    -0.81857196, 0.57068042, -0.06529777,
    0.00259991, 0.57567966, 0.81767118,
    0.58750054, 0.55480054, 0.58910057,
    0.60319587, 0.62429573, -0.49639660,
    -0.33320225, 0.56900384, -0.75180509,
    -0.71212531, 0.57632048, 0.40091426,
    -0.81811104, 0.56370763, -0.11370153,
    0.02780073, 0.57451521, 0.81802163,
    0.81507494, 0.57298238, -0.08569736,
    0.05349856, 0.60348376, -0.79557857,
    0.68310969, 0.56330805, -0.46480661,
    -0.46459885, 0.59249850, -0.65809836,
    -0.67209622, 0.56449679, 0.47919730,
    0.45509842, 0.59529793, 0.66219771,
    0.81861228, 0.57110858, 0.06090092,
    0.06100070, 0.58420670, -0.80930924,
    -0.81688492, 0.57228946, -0.07199866,
    -0.07050135, 0.58271117, 0.80961550,
    -0.60497150, 0.55487386, -0.57107309,
    -0.60851182, 0.63251229, 0.47920932,
    0.33079776, 0.56309616, 0.75729489,
    0.69198869, 0.57779055, -0.43279294,
    0.82243486, 0.56722406, -0.04310183,
    -0.06799782, 0.58528125, -0.80797410,
    -0.81838946, 0.56819265, 0.08599889,
    0.05889892, 0.59158919, 0.80408529,
    0.68110065, 0.56000053, -0.47170045,
    -0.48981294, 0.59361565, -0.63851684,
    -0.65739256, 0.56439364, 0.49929434,
    0.45248983, 0.59928658, 0.66038515,
  ]),
  materialIndex: 1,
};

const MIND_MESH_2: RuneMesh = {
  name: "Mind_Rune_primitive2",
  positions: new Float32Array([
    0.35150000, 0.35720003, 0.21139997,
    0.39469999, 0.35720000, -0.16330002,
    0.16650000, 0.35719997, -0.39380002,
    0.02720000, 0.35720003, 0.44919997,
    0.02720000, 0.35720003, 0.29789996,
    0.02720000, 0.35720003, 0.29789996,
    0.20739999, 0.35720003, 0.20899998,
    0.25780001, 0.35720000, -0.16090003,
    0.15930000, 0.35719997, -0.25450003,
    -0.10970000, 0.35719997, -0.30020002,
    -0.21300000, 0.35719997, -0.20650002,
    -0.25860000, 0.35720000, 0.16579998,
    -0.39789999, 0.35720000, 0.16819997,
    -0.34990001, 0.35719997, -0.21370003,
    -0.34990001, 0.35719997, -0.21370003,
    -0.11690000, 0.35719997, -0.44190004,
    0.02000000, 0.35720000, 0.02889997,
    0.12330000, 0.35720000, 0.02649997,
    0.15449999, 0.35720000, -0.16090003,
    0.06330000, 0.35720000, -0.16090003,
    -0.01600000, 0.35720000, -0.02150003,
    -0.02800000, 0.35719997, -0.20410003,
    -0.11690000, 0.35719997, -0.20410003,
    -0.11690000, 0.35720000, -0.02150003,
  ]),
  indices: new Uint16Array([
    17, 16, 19, 17, 19, 18, 21, 20, 23, 21, 23, 22,
    10, 11, 13, 15, 2, 1, 0, 3, 4, 0, 4, 6,
    10, 13, 15, 9, 10, 15, 1, 0, 6, 1, 6, 7,
    8, 9, 15, 1, 7, 8, 8, 15, 1, 5, 3, 12,
    12, 14, 11, 12, 11, 5,
  ]),
  normals: new Float32Array([
    -0.67338606, 0.62718704, -0.39139191,
    -0.74053262, 0.62142740, 0.25581130,
    -0.35269687, 0.64429427, 0.67859400,
    -0.01970048, 0.58841426, -0.80831958,
    0.00730001, 0.81980160, 0.57260112,
    0.00000000, 0.81982346, 0.57261636,
    0.63982029, -0.61511953, 0.46071462,
    0.74220919, -0.61750763, -0.26040321,
    0.34141967, -0.64693725, -0.68183928,
    -0.21989657, -0.62069027, -0.75258826,
    -0.68492749, -0.63632557, -0.35491423,
    -0.70188263, -0.59558526, 0.39069037,
    0.72319380, 0.60539482, -0.33239712,
    0.68833069, 0.64002852, 0.34141522,
    0.68830717, 0.64000667, 0.34150359,
    0.23509423, 0.61778488, 0.75038160,
    0.63873512, 0.56543107, -0.52182866,
    -0.53000802, 0.58790892, -0.61110932,
    -0.62736498, 0.56916820, 0.53147035,
    0.50349557, 0.59009486, 0.63109451,
    -0.59770437, 0.57400420, -0.55970409,
    -0.55637234, 0.58087116, 0.59417044,
    0.57738361, 0.57738361, 0.57728359,
    0.57728359, 0.57738361, -0.57738361,
  ]),
  materialIndex: 2,
};

export const MIND_MESHES: RuneMesh[] = [
  MIND_MESH_0,
  MIND_MESH_1,
  MIND_MESH_2,
];
